export default __webpack_public_path__ + "d416565e3f291aa42b3f51ae62b52dc2.png";